import React, { useState, useEffect } from 'react';
import { Modal, Button, Alert, Form, Collapse, Spinner } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import Select from 'react-select';
import ProspectoFormatacaoDados from '../ProspectoFormatacaoDados';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const ModalTransferenciaSocio = ({
  showModal,
  socio,
  prospecto,
  onClose,
  fetchProspectoDetalhes,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [empreendimentoSelecionado, setEmpreendimentoSelecionado] = useState(
    ''
  );
  const [empreendimentosDisponiveis, setEmpreendimentosDisponiveis] = useState(
    []
  );
  const [mostrarDetalhesSocio, setMostrarDetalhesSocio] = useState(false);

  useEffect(() => {
    if (prospecto && prospecto.prospecto_empreendimento) {
      const empreendimentosFiltrados = prospecto.prospecto_empreendimento.filter(
        item => item.empreendimento.codigo !== prospecto.codigo_familia
      );
      setEmpreendimentosDisponiveis(empreendimentosFiltrados);
    }
  }, [prospecto]);

  const handleTransferencia = async () => {
    try {
      if (!empreendimentoSelecionado) {
        toast.error('Selecione um empreendimento para transferência');
        return;
      }

      setIsLoading(true);

      const empreendimentoObj = empreendimentosDisponiveis.find(
        item => item.codigo_familia === Number(empreendimentoSelecionado)
      );

      if (!empreendimentoObj) {
        toast.error('Empreendimento não encontrado');
        setIsLoading(false);
        return;
      }

      const auxSocio = {
        ...socio,
        codigo_familia: empreendimentoObj.codigo_familia,
        codigo_conta: empreendimentoObj.codigo_conta,
        codigo_grupo_empresa: empreendimentoObj.codigo_grupo_empresa,
        codigo_corretor: empreendimentoObj.codigo_corretor,
        codigo_gerente: empreendimentoObj.codigo_gerente,
        codigo: 0,
        sequencia: 0,
      };

      const response = await api.copiarSocioConjuge({
        socio: auxSocio,
        familia_existente: socio.codigo_familia,
      });

      toast.success(response.message);
      fetchProspectoDetalhes(socio.codigo_prospecto_cliente);
    } catch (error) {
      toast.error(error.message || 'Erro ao realizar transferência');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Modal show={showModal} onHide={onClose} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Transferência de Sócio/Cônjuge</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {socio && prospecto && (
          <>
            <div className="row mb-3">
              <div className="col-12">
                <Form.Group>
                  <Form.Label className="text-primary">
                    <strong>
                      Selecione o empreendimento para transferência
                    </strong>
                  </Form.Label>
                  {empreendimentosDisponiveis.length > 0 ? (
                    <Select
                      value={(() => {
                        const empreendimento = empreendimentosDisponiveis.find(
                          item =>
                            item.empreendimento.codigo.toString() ===
                            empreendimentoSelecionado.toString()
                        );
                        if (empreendimento) {
                          return {
                            value: empreendimentoSelecionado,
                            label: empreendimento.empreendimento.descricao,
                          };
                        }
                        return null;
                      })()}
                      options={empreendimentosDisponiveis.map(item => ({
                        value: item.empreendimento.codigo,
                        label: item.empreendimento.descricao,
                      }))}
                      onChange={selectedOption =>
                        setEmpreendimentoSelecionado(
                          selectedOption ? selectedOption.value : ''
                        )
                      }
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      placeholder="Selecione um empreendimento"
                      isSearchable={true}
                      isDisabled={isLoading}
                    />
                  ) : (
                    <Alert variant="warning">
                      Não há outros empreendimentos disponíveis para
                      transferência.
                    </Alert>
                  )}
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="mb-0">Dados do Sócio/Cônjuge</h5>
                  <div style={{ width: '150px' }}>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() =>
                        setMostrarDetalhesSocio(!mostrarDetalhesSocio)
                      }
                      className="d-flex align-items-center w-100 justify-content-between"
                      style={{
                        ...customStyles.control({}, {}).style,
                        padding: '8px 12px',
                        border: '1px solid #ced4da',
                        borderRadius: '0.25rem',
                        boxShadow: 'none',
                        height: '38px',
                      }}
                    >
                      {mostrarDetalhesSocio ? (
                        <>
                          <span>Ocultar Detalhes</span>
                          <FaChevronUp />
                        </>
                      ) : (
                        <>
                          <span>Ver Detalhes</span>
                          <FaChevronDown />
                        </>
                      )}
                    </Button>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-12">
                    <div className="card p-2 bg-light">
                      <div className="d-flex justify-content-between">
                        <div>
                          <small className="d-block text-muted">Nome</small>
                          <strong>{socio.nome || 'N/A'}</strong>
                        </div>
                        <div>
                          <small className="d-block text-muted">CPF</small>
                          <strong>{socio.cpf || 'N/A'}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Collapse in={mostrarDetalhesSocio} timeout={300}>
                  <div>
                    <div className="row mt-2">
                      <div className="col-12 col-md-6">
                        <ul className="list-unstyled line-height-1">
                          <ProspectoFormatacaoDados
                            prospecto={socio}
                            isDadosPessoais={true}
                          >
                            {({ values }) =>
                              values.map((item, index) => (
                                <li key={index} className="mb-2">
                                  <small className="d-block">
                                    {item.label}
                                  </small>
                                  <strong className="d-block">
                                    {item.value}
                                  </strong>
                                </li>
                              ))
                            }
                          </ProspectoFormatacaoDados>
                        </ul>
                      </div>
                      <div className="col-12 col-md-6">
                        <ul className="list-unstyled line-height-1">
                          <ProspectoFormatacaoDados
                            prospecto={socio}
                            isDadosPessoais={false}
                          >
                            {({ values }) =>
                              values.map((item, index) => (
                                <li key={index} className="mb-2">
                                  <small className="d-block">
                                    {item.label}
                                  </small>
                                  <strong className="d-block">
                                    {item.value}
                                  </strong>
                                </li>
                              ))
                            }
                          </ProspectoFormatacaoDados>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleTransferencia}
          disabled={
            isLoading ||
            !empreendimentoSelecionado ||
            empreendimentosDisponiveis.length === 0
          }
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="mr-2"
              />
              Copiando sócio/cônjuge...
            </>
          ) : (
            'Confirmar Transferência'
          )}
        </Button>
        <Button variant="secondary" onClick={onClose} disabled={isLoading}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTransferenciaSocio;
